import React, { useContext, useState } from 'react'
import { Formik, Form as FormikForm, useFormikContext } from 'formik'
import Box from '@material-ui/core/Box'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import { R, sumCurrency } from '../../../../../utils/currency'
import { FnaContext } from '../../../context'
import { CardContent } from '../../../../../components/layout/Card'
import { buildInitialValues } from './initialValues'
import { setupValidationSchema } from './validations'
import { NumberFieldWithLabel } from '../../../../../components/Form/Fields'
import { Button } from '../../../../../components/Button'
import { Spotlight } from '../../../../../components/Spotlight'
import { Aside } from '../../../Components/Form/Aside'
import { ASIDE_VIEWS } from '../../../reducer'

import { ASSESSMENT_TYPE, FORM_ACTIONS } from '../../../reducer'

// TODO: Current form has no mobile designs
export const Form = () => {
  const { actions: { submit } } = useContext(FnaContext)
  const [asideView, setAsideView] = useState(false)

  return (
    <CardContent>
      <Formik
        onSubmit={(values) => submit(values, ASSESSMENT_TYPE.DISABILITY_COVER)}
        initialValues={buildInitialValues()}
        validationSchema={setupValidationSchema()}
        render={({ values }) => (
          <FormikForm>
            <FormSpotlights values={values} />
            <div className='grid grid-cols-2'>
              <Main
                setAsideView={setAsideView}
              />
              <Aside
                asideView={asideView}
              />
            </div>
          </FormikForm>
        )}
      />
    </CardContent>
  )
}

const Main = ({ setAsideView }) => {
  const { values, isValid, isSubmitting } = useFormikContext()
  const {
    state: {
      formAction,
      liabilities,
      riskProducts,
      loading
    },
    actions: { goToIndex, goToDelete }
  } = useContext(FnaContext)

  const liabilitiesExist = !isEmpty(liabilities)
  const riskProductsExist = !isEmpty(riskProducts)

  const newForm = formAction === FORM_ACTIONS.CREATE

  return (
    <div className='app-form'>
      <h3>Things to pay for immediately</h3>
      <NumberFieldWithLabel
        label='Lifestyle adjustment'
        name='lifestyle_adjustment_expenses'
      />
      <Box
        className='flex items-end justify-between mr-4'
      >
        <NumberFieldWithLabel
          readOnly
          value={get(values, 'total_liabilities_expenses', 0)}
          style={{ flex: 2 }}
          label='Total liabilities value'
          name='total_liabilities_expenses'
        />
        <Button
          trackAs="Disability cover: Select liabilities"
          style={{ flex: 1 }}
          disabled={!liabilitiesExist}
          primary onClick={() => {
            setAsideView(ASIDE_VIEWS.LIABILITIES)
          }}>Select Liabilities</Button>
      </Box>
      {!liabilitiesExist && <small className='ml-4 mb-2'>You do not have any liabilities</small>}

      <h3>Existing cover</h3>
      <Box
        className='flex items-end justify-between mr-4'
      >
        <NumberFieldWithLabel
          readOnly
          value={get(values, 'total_from_selected_risk_products', 0)}
          style={{ flex: 2 }}
          label='Total risk cover value'
          name='total_from_selected_risk_products'
        />
        <Button
          trackAs="Disability cover: Select disability cover products"
          style={{ flex: 1 }}
          disabled={!riskProductsExist}
          primary onClick={() => {
            setAsideView(ASIDE_VIEWS.RISK_PRODUCTS)
          }}>Select disability cover products</Button>
      </Box>
      {!riskProductsExist && <small className='ml-4 mb-2'>You do not have any disability cover products</small>}
      <NumberFieldWithLabel
        label='Other lump sum cover'
        name='existing_cover'
      />

      <Box className='grid grid-cols-2 gap-4 mt-4'>
        <Button secondary onClick={goToIndex}>Go Back</Button>
        <Button
          trackAs="Disability cover: Complete assessment"
          disabled={!isValid || isSubmitting || loading} primary type='submit'
        >
          {loading ? "Calculating..." : "Calculate"}
        </Button>
        {!newForm &&
          <Button
            disabled={loading}
            trackAs="Disability cover: Delete" tertiary onClick={goToDelete(ASSESSMENT_TYPE.DISABILITY_COVER)}
            className="button col-span-2"
          >
            {loading ? 'Loading...' : "Delete assessment"}
          </Button>
        }
      </Box>
    </div>
  )
}

const FormSpotlights = ({ values }) => {
  return (
    <Box
      className='flex justify-between px-12 my-4'
    >
      <Spotlight
        value={sumCurrency([get(values, 'existing_cover', 0), get(values, 'total_from_selected_risk_products', 0)]).format()}
        description={`Existing cover`} />
      <Spotlight
        value={sumCurrency([get(values, 'total_liabilities_expenses', 0), get(values, 'lifestyle_adjustment_expenses', 0)]).format()}
        description={`Required cover`} />
    </Box>
  )
}
